/**
 * @generated SignedSource<<39f9212297da4950cb7dea5aff45b4cd>>
 * @lightSyntaxTransform
 * @nogrep
 */
const node = (function () {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": 20,
        "kind": "LocalArgument",
        "name": "first"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "id"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "model"
    }, v4 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
        }
    ], v5 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "after"
        },
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "first"
        },
        {
            "kind": "Variable",
            "name": "model",
            "variableName": "model"
        }
    ], v6 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
    }, v8 = {
        "kind": "InlineFragment",
        "selections": [
            (v7 /*: any*/)
        ],
        "type": "Node",
        "abstractKey": "__isNode"
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "start",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "color",
        "storageKey": null
    }, v11 = [
        (v10 /*: any*/),
        (v7 /*: any*/)
    ], v12 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v13 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "end",
        "storageKey": null
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v2 /*: any*/),
                (v3 /*: any*/)
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "MySchedulePaginationContent_shiftsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "args": (v5 /*: any*/),
                            "kind": "FragmentSpread",
                            "name": "MySchedulePaginationContent_shifts"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                (v0 /*: any*/),
                (v1 /*: any*/),
                (v3 /*: any*/),
                (v2 /*: any*/)
            ],
            "kind": "Operation",
            "name": "MySchedulePaginationContent_shiftsQuery",
            "selections": [
                {
                    "alias": null,
                    "args": (v4 /*: any*/),
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        (v6 /*: any*/),
                        (v7 /*: any*/),
                        {
                            "kind": "InlineFragment",
                            "selections": [
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeConnection",
                                    "kind": "LinkedField",
                                    "name": "scheduleItems",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ICanBeUsedToCalculateScheduleTimesUnionTypeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": null,
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        (v8 /*: any*/),
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                (v9 /*: any*/),
                                                                (v7 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "assignedEntity",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v6 /*: any*/),
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "Asset",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "asset",
                                                                                    "plural": false,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableAsset",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "User",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "user",
                                                                                    "plural": false,
                                                                                    "selections": (v11 /*: any*/),
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "SchedulableUser",
                                                                            "abstractKey": null
                                                                        },
                                                                        (v8 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "AssignmentType",
                                                                    "kind": "LinkedField",
                                                                    "name": "assignmentType",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "title",
                                                                            "storageKey": null
                                                                        },
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Schedule",
                                                                    "kind": "LinkedField",
                                                                    "name": "schedule",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v12 /*: any*/),
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v13 /*: any*/),
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShiftConnection",
                                                                    "kind": "LinkedField",
                                                                    "name": "simultaneousScheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "concreteType": "ScheduleShiftEdge",
                                                                            "kind": "LinkedField",
                                                                            "name": "edges",
                                                                            "plural": true,
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ScheduleShift",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "node",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        (v7 /*: any*/),
                                                                                        {
                                                                                            "alias": null,
                                                                                            "args": null,
                                                                                            "concreteType": null,
                                                                                            "kind": "LinkedField",
                                                                                            "name": "assignedEntity",
                                                                                            "plural": false,
                                                                                            "selections": [
                                                                                                (v6 /*: any*/),
                                                                                                {
                                                                                                    "kind": "InlineFragment",
                                                                                                    "selections": [
                                                                                                        (v7 /*: any*/),
                                                                                                        {
                                                                                                            "alias": null,
                                                                                                            "args": null,
                                                                                                            "concreteType": "Asset",
                                                                                                            "kind": "LinkedField",
                                                                                                            "name": "asset",
                                                                                                            "plural": false,
                                                                                                            "selections": [
                                                                                                                (v12 /*: any*/),
                                                                                                                (v10 /*: any*/),
                                                                                                                (v7 /*: any*/)
                                                                                                            ],
                                                                                                            "storageKey": null
                                                                                                        }
                                                                                                    ],
                                                                                                    "type": "SchedulableAsset",
                                                                                                    "abstractKey": null
                                                                                                },
                                                                                                (v8 /*: any*/)
                                                                                            ],
                                                                                            "storageKey": null
                                                                                        }
                                                                                    ],
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "status",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Event",
                                                                    "kind": "LinkedField",
                                                                    "name": "event",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v7 /*: any*/),
                                                                        (v12 /*: any*/),
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isWork",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "isAbsence",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "type": "ScheduleShift",
                                                            "abstractKey": null
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ScheduleShift",
                                                                    "kind": "LinkedField",
                                                                    "name": "scheduleShift",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v9 /*: any*/),
                                                                        (v7 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "Event",
                                                                    "kind": "LinkedField",
                                                                    "name": "reasonEvent",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v12 /*: any*/),
                                                                        (v7 /*: any*/),
                                                                        (v10 /*: any*/)
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                (v9 /*: any*/),
                                                                (v13 /*: any*/)
                                                            ],
                                                            "type": "ScheduleShiftAssigneeReplacement",
                                                            "abstractKey": null
                                                        },
                                                        (v6 /*: any*/)
                                                    ],
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "cursor",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "totalCount",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "PageInfo",
                                            "kind": "LinkedField",
                                            "name": "pageInfo",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "endCursor",
                                                    "storageKey": null
                                                },
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "hasNextPage",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                },
                                {
                                    "alias": null,
                                    "args": (v5 /*: any*/),
                                    "filters": [
                                        "model"
                                    ],
                                    "handle": "connection",
                                    "key": "MySchedulePaginationContent_scheduleItems",
                                    "kind": "LinkedHandle",
                                    "name": "scheduleItems"
                                }
                            ],
                            "type": "SchedulableUser",
                            "abstractKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "0a7dbc772a62d5dc9a35e1e6ba6058a3",
            "id": null,
            "metadata": {},
            "name": "MySchedulePaginationContent_shiftsQuery",
            "operationKind": "query",
            "text": "query MySchedulePaginationContent_shiftsQuery(\n  $after: String\n  $first: Int = 20\n  $model: GetRunningScheduleRequestInput!\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...MySchedulePaginationContent_shifts_1jPC5b\n    id\n  }\n}\n\nfragment MySchedulePaginationContent_shifts_1jPC5b on SchedulableUser {\n  scheduleItems(model: $model, first: $first, after: $after) {\n    edges {\n      node {\n        ... on Node {\n          __isNode: __typename\n          id\n        }\n        ... on ScheduleShift {\n          start\n        }\n        ... on ScheduleShiftAssigneeReplacement {\n          scheduleShift {\n            start\n            id\n          }\n        }\n        __typename\n        ...ScheduleShiftCard_scheduleShift\n        ...ScheduleShiftAbsenceCard_scheduleShiftAssigneeReplacement\n      }\n      cursor\n    }\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  id\n}\n\nfragment ScheduleShiftAbsenceCard_scheduleShiftAssigneeReplacement on ScheduleShiftAssigneeReplacement {\n  reasonEvent {\n    name\n    id\n    color\n  }\n  start\n  end\n  scheduleShift {\n    id\n  }\n}\n\nfragment ScheduleShiftCard_scheduleShift on ScheduleShift {\n  id\n  assignedEntity {\n    __typename\n    ... on SchedulableAsset {\n      asset {\n        color\n        id\n      }\n    }\n    ... on SchedulableUser {\n      user {\n        color\n        id\n      }\n    }\n    ... on Node {\n      __isNode: __typename\n      id\n    }\n  }\n  assignmentType {\n    title\n    id\n  }\n  schedule {\n    name\n    id\n  }\n  end\n  simultaneousScheduleShift {\n    edges {\n      node {\n        id\n        assignedEntity {\n          __typename\n          ... on SchedulableAsset {\n            id\n            asset {\n              name\n              color\n              id\n            }\n          }\n          ... on Node {\n            __isNode: __typename\n            id\n          }\n        }\n      }\n    }\n  }\n  start\n  status\n  event {\n    id\n    name\n    isWork\n    isAbsence\n  }\n}\n"
        }
    };
})();
node.hash = "01a0ceeda1e270f5ad1fa014af0bf39b";
export default node;
